import gql from 'graphql-tag';

export const getPropertyExternalReferencesQuery = gql(`
  query getPropertyExternalReferences($propertyId: UUID!) {
    property(propertyId: $propertyId) {
      id
      externalReferences {
        id
        direct
        source {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        relationshipSource {
          sourceType
          sourceRelationshipType
          sourceRelationshipId
        }
      }
    }
  }
`);
